// All support-tickets related apis
import { API_URL } from "./api";
import instance from "./api";
import { encryptData } from "../helpers/encryptDecrypt";

// Get api for fetching all support tickets issued by active user
export const fetchSupportTickets = async (keyword) => {
  return await instance.get(`${API_URL}/support-tickets?keyword=${keyword}`);
};

// Post api for issuing a new support ticket
export const addSupportTicket = async (data) => {
  return await instance.post(`${API_URL}/support-ticket`, data);
};

// Post api for cancelling the existing support ticket
export const cancelSupportTicket = async (id) => {
  const sId = encryptData(id);
  return await instance.post(`${API_URL}/support-ticket/cancel/${sId}`, {});
};

// Post api for re-opening of the exisitng support ticket
export const reOpenSupportTicket = async (id) => {
  const sId = encryptData(id);
  return await instance.post(`${API_URL}/support-ticket/re-open/${sId}`, {});
};

// Delete api for deleting the existing support ticket
export const deleteSupportTickets = async (id) => {
  const sId = encryptData(id);
  return await instance.delete(`${API_URL}/support-ticket/${sId}`);
};

// Post api for sending chat/message for the selected support ticket
export const sendSupportTicketsMessage = async (id, data) => {
  const sId = encryptData(id);
  return await instance.post(`${API_URL}/support-ticket-message/${sId}`, data);
};

// Get api for fetching all the chat/messages fot the selected support ticket
export const fetchSupportTicketsMessages = async (id) => {
  const sId = encryptData(id);
  return await instance.get(`${API_URL}/support-ticket-message/${sId}`);
};